import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const passwordSlide = createSlice({
    name: "password",
    initialState: {
        updatePasswordSuccess: false,
        updatePasswordFail: false,
        updatePasswordErrorDetail: null,

        forgotPasswordSuccess: false,
        forgotPasswordFail: false,
        forgotPasswordErrorDetail: null,

        verifyOTPSuccess: false,
        verifyOTPFail: false,
        verifyOTPErrorDetail: null,

        resetPasswordSuccess: false,
        resetPasswordFail: false,
        resetPasswordErrorDetail: null,
    },
    reducers: {
        doUpdatePasswordSuccess: (state, action) => {
            state.updatePasswordSuccess = true;
            state.updatePasswordFail = false;
            state.updatePasswordErrorDetail = null;
        },
        doUpdatePasswordFail: (state, action) => {
            state.updatePasswordSuccess = false;
            state.updatePasswordFail = true;
            state.updatePasswordErrorDetail = action.payload?.data;
        },
        resetUpdatePasswordState: (state, action) => {
            state.updatePasswordSuccess = false;
            state.updatePasswordFail = false;
            state.updatePasswordErrorDetail = null;
        },
        //
        doForgotPasswordSuccess: (state, action) => {
            state.forgotPasswordSuccess = true;
            state.forgotPasswordFail = false;
            state.forgotPasswordErrorDetail = null;
        },
        doForgotPasswordFail: (state, action) => {
            state.forgotPasswordSuccess = false;
            state.forgotPasswordFail = true;
            state.forgotPasswordErrorDetail = action.payload?.data;
        },
        resetForgotPasswordState: (state, action) => {
            state.forgotPasswordSuccess = false;
            state.forgotPasswordFail = false;
            state.forgotPasswordErrorDetail = null;
        },
        //
        doVerifyOTPSuccess: (state, action) => {
            state.verifyOTPSuccess = true;
            state.verifyOTPFail = false;
            state.verifyOTPErrorDetail = null;
        },
        doVerifyOTPFail: (state, action) => {
            state.verifyOTPSuccess = false;
            state.verifyOTPFail = true;
            state.verifyOTPErrorDetail = action.payload?.data;
        },
        resetVerifyOTPState: (state, action) => {
            state.verifyOTPSuccess = false;
            state.verifyOTPFail = false;
            state.verifyOTPErrorDetail = null;
        },
        //
        doResetPasswordSuccess: (state, action) => {
            state.resetPasswordSuccess = true;
            state.resetPasswordFail = false;
            state.resetPasswordErrorDetail = null;
        },
        doResetPasswordFail: (state, action) => {
            state.resetPasswordSuccess = false;
            state.resetPasswordFail = true;
            state.resetPasswordErrorDetail = action.payload?.data;
        },
        resetResetPasswordState: (state, action) => {
            state.resetPasswordSuccess = false;
            state.resetPasswordFail = false;
            state.resetPasswordErrorDetail = null;
        },
    },
});

export const doUpdatePassword = (param) => async (dispatch) => {
	try {
        const url = `/api/customer/auth/password`;
        const response = await axios.put(url, param);

        dispatch(doUpdatePasswordSuccess(response.data));
    } catch (error) {
        dispatch(doUpdatePasswordFail(error.response));
    }
};

export const doResetUpdatePasswordState = () => async (dispatch) => {
    dispatch(resetUpdatePasswordState());
};

export const doForgotPassword = (param) => async (dispatch) => {
	try {
        const url = `/api/customer/auth/forgot-password`;
        const response = await axios.post(url, param);

        dispatch(doForgotPasswordSuccess(response.data));
    } catch (error) {
        dispatch(doForgotPasswordFail(error.response));
    }
};

export const doResetForgotPasswordState = () => async (dispatch) => {
    dispatch(resetForgotPasswordState());
};

export const doVerifyResetOTP = (param) => async (dispatch) => {
	try {
        const url = `/api/customer/auth/verify-otp`;
        const response = await axios.post(url, param);

        dispatch(doVerifyOTPSuccess(response.data));
    } catch (error) {
        dispatch(doVerifyOTPFail(error.response));
    }
};

export const doResetVerifyOTPState = () => async (dispatch) => {
    dispatch(resetVerifyOTPState());
};

export const doResetPassword = (param) => async (dispatch) => {
	try {
        const url = `/api/customer/auth/update-reset-password`;
        const response = await axios.post(url, param);

        dispatch(doResetPasswordSuccess(response.data));
    } catch (error) {
        dispatch(doResetPasswordFail(error.response));
    }
};

export const doResetResetPasswordState = () => async (dispatch) => {
    dispatch(resetResetPasswordState());
};

export const {
    doUpdatePasswordSuccess,
    doUpdatePasswordFail,
    resetUpdatePasswordState,
    doForgotPasswordSuccess,
    doForgotPasswordFail,
    resetForgotPasswordState,
    doVerifyOTPSuccess,
    doVerifyOTPFail,
    resetVerifyOTPState,
    doResetPasswordSuccess,
    doResetPasswordFail,
    resetResetPasswordState,
} = passwordSlide.actions;

export const getUpdatePasswordSuccess = (state) => state.password?.updatePasswordSuccess;
export const getUpdatePasswordFail = (state) => state.password?.updatePasswordFail;
export const getUpdatePasswordErrorDetail = (state) => state.password?.updatePasswordErrorDetail;

export const getForgotPasswordSuccess = (state) => state.password?.forgotPasswordSuccess;
export const getForgotPasswordFail = (state) => state.password?.forgotPasswordFail;
export const getForgotPasswordErrorDetail = (state) => state.password?.forgotPasswordErrorDetail;

export const getVerifyOTPSuccess = (state) => state.password?.verifyOTPSuccess;
export const getVerifyOTPFail = (state) => state.password?.verifyOTPFail;
export const getVerifyOTPErrorDetail = (state) => state.password?.verifyOTPErrorDetail;

export const getResetPasswordSuccess = (state) => state.password?.resetPasswordSuccess;
export const getResetPasswordFail = (state) => state.password?.resetPasswordFail;
export const getResetPasswordErrorDetail = (state) => state.password?.resetPasswordErrorDetail;

export default passwordSlide.reducer;